/**
 * ItemCatalog — all consumable item definitions.
 */

import type { ItemDef } from "./ItemDef";

export const ITEM_SHUFFLE: ItemDef = {
  id: "shuffle",
  name: "Shuffle",
  description: "Reshuffle all grid letters",
  color: "#8b5cf6",
  icon: "~",
};

export const ALL_ITEMS: ItemDef[] = [
  ITEM_SHUFFLE,
];
